
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as iframe_testGqe9rXl0HAIJkHP0kwFvWfMoAR_cRO0R1Ftc9yPu1ZwMeta } from "/app/apps/frontend/src/pages/embed/teacher/ai/iframe_test.vue?macro=true";
import { default as indexeNuUcVS_1BM21n_tkpVGKAcg06OcZ3lhetc_3wGti_wMeta } from "/app/apps/frontend/src/pages/embed/student/course/[code]/item-detail/[id]/index.vue?macro=true";
import { default as _91code_93mZ0FfbUA8t1sgey73R4COXrLaNwUCxgsNKtLKPkkVPoMeta } from "/app/apps/frontend/src/pages/embed/student/course/[code].vue?macro=true";
import { default as _91code_93HTMA7d8XHlKRh6aL33Cu5zPnJTQjFj0JTjxCz_kIJAgMeta } from "/app/apps/frontend/src/pages/embed/teacher/course/[code].vue?macro=true";
import { default as _91courseId_93owv1bT9nR1KghoBWy60wwEZMVa1cPw5yC0I_ajRE8a0Meta } from "/app/apps/frontend/src/pages/embed/teacher/period/[courseId].vue?macro=true";
import { default as _91id_93xkR_H_OJATUIWvU6Ltj14Wzs8kUBtpXJn5Vjb6PU0mIMeta } from "/app/apps/frontend/src/pages/student-ai/assignments/preview/[id].vue?macro=true";
import { default as _91id_93rqmjAq0xHuRYcow9TlUPNpDuNvF9TT4xZxScBwhBRAQMeta } from "/app/apps/frontend/src/pages/student-ai/templates/preview/[id].vue?macro=true";
import { default as _91id_93LXahq8ZvnNIN40i6LEBDF3FlxxxxYdA9GcWkVBjgSxEMeta } from "/app/apps/frontend/src/pages/student-ai/templates/public-preview/[id].vue?macro=true";
import { default as admininfosUwQxeSgNauT769PNEKvV2kjq6yjRZdDm3KhX_Z7HlEMeta } from "/app/apps/frontend/src/pages/auth/integration/admininfo.vue?macro=true";
import { default as authenticateOGw6Vt_FfXHFyVGUJISZAhnazH_tI7k_8_qupc_hFqsMeta } from "/app/apps/frontend/src/pages/auth/integration/authenticate.vue?macro=true";
import { default as not_ready_7XICRBXlcjdszwSVo_tLlgpjzCaYe0kD6WJvUMraqcMeta } from "/app/apps/frontend/src/pages/auth/integration/not_ready.vue?macro=true";
import { default as not_ready_studentukdnyHVi_ZYZ7bnhrWGEilS7biGcLceCCaxang4sdWYMeta } from "/app/apps/frontend/src/pages/auth/integration/not_ready_student.vue?macro=true";
import { default as no_45authyw_IDyAX3GLe6d1m1mSGf0a2QyH5Xki1ejAPLj1gX5AMeta } from "/app/apps/frontend/src/pages/embed/error/no-auth.vue?macro=true";
import { default as no_45courseYC4rPQhoJZYIhdOvIG4h1HomZZPO_rnQ4d_8sZF4F3MMeta } from "/app/apps/frontend/src/pages/embed/student/no-course.vue?macro=true";
import { default as indexnjPM4XY7Hh6QYM3ocWBFtvTmPuX1ZjrCxDxV0NSlG0oMeta } from "/app/apps/frontend/src/pages/embed/teacher/ai/index.vue?macro=true";
import { default as errorxgWEgtY_Ucl32sVdaMjGndovyTMmbmHmS565A95wRJ0Meta } from "/app/apps/frontend/src/pages/embed/teacher/error.vue?macro=true";
import { default as no_45accountTYZvuDk2_OOoYF4oUYpeZMmXygH9fJMrTEzYAvoxwJYMeta } from "/app/apps/frontend/src/pages/embed/teacher/no-account.vue?macro=true";
import { default as no_45course_45mappingpzg50rrvYPWtONuIzp4_FGSfnxy4KHZot0_SqDQ6oAUMeta } from "/app/apps/frontend/src/pages/embed/teacher/no-course-mapping.vue?macro=true";
import { default as ai_45settingsRKFUK1WOpSssO_xMy8UjzxPTQ_7nnIDJt6Egttn6tS8Meta } from "/app/apps/frontend/src/pages/collaboration/template/[templateid]/ai-settings.vue?macro=true";
import { default as collaborationW66LmG3h_Nl_r6g68mwjgMGIpQaaZlepAMqm0HhmcMwMeta } from "/app/apps/frontend/src/pages/collaboration/template/[templateid]/collaboration.vue?macro=true";
import { default as settings9xLitFfz0eslAFHbMGAi6YkZ6j_FEujp8xJbjg9Dt60Meta } from "/app/apps/frontend/src/pages/collaboration/template/[templateid]/settings.vue?macro=true";
import { default as _91code_93as4zAI6xg_GsO64OUSN5W_8TNveCGqykYEuNFyy7OX4Meta } from "/app/apps/frontend/src/pages/auth/reset-password/[email]/[code].vue?macro=true";
import { default as _91id_9328a0MFrU_CI4X_4oK6wqAcr2K6f97D2vUt5egAAUq3wMeta } from "/app/apps/frontend/src/pages/ai/chat/[id].vue?macro=true";
import { default as index9eF__7BaBacCkwqCQpBIY6vZEeJn2LtIeZku8DhbbTUMeta } from "/app/apps/frontend/src/pages/collaboration/template/[templateid]/index.vue?macro=true";
import { default as _91courseCode_93zJSfJ1_CGVq6iVcmy23eIygogokABF_H7uLhf90RDa0Meta } from "/app/apps/frontend/src/pages/invite/course/[courseCode].vue?macro=true";
import { default as _91tenantCode_93Fs0dRb1ImnHzEAhfSIYCz_HxZTWnXE7kFmxngYOIfM8Meta } from "/app/apps/frontend/src/pages/invite/tenant/[tenantCode].vue?macro=true";
import { default as _91id_93ISS5HtTnVBM5X9W947BX8ZT1KS6yTNrAV1KZMPUBIzoMeta } from "/app/apps/frontend/src/pages/library/material/[id].vue?macro=true";
import { default as _91id_93Awpi_IefJ62wYW5G8SRS1pcMvN3mqGIcow5jco3XuQgMeta } from "/app/apps/frontend/src/pages/library/topic/[id].vue?macro=true";
import { default as _91id_93rm7mjKAKvSQ3_1_kjt6xNkJypd68ubz6QTAi7t1BLj8Meta } from "/app/apps/frontend/src/pages/presentation/material/[id].vue?macro=true";
import { default as discoverproNyMWlV8yQp4xVshCgRy1ckZgou78Vi37KUwlCO8AnrUMeta } from "/app/apps/frontend/src/pages/account/discoverpro.vue?macro=true";
import { default as integrationsC1r5O4D0a4OA79rpZJmbAWxZMIw_Ch6h7ha0v_m9IQUMeta } from "/app/apps/frontend/src/pages/account/integrations.vue?macro=true";
import { default as profileUnF62GpJiyfeo2VTAnNkJcNiENjOiQESe4lR3Ki7DzQMeta } from "/app/apps/frontend/src/pages/account/profile.vue?macro=true";
import { default as upgradeukcMHmOU6jmEjVJ_c2ZQ4FG53eh3u0_a47jOo33fn08Meta } from "/app/apps/frontend/src/pages/account/upgrade.vue?macro=true";
import { default as upgrade_45successfulzMZYY98uz65fVM9MP2u6DSD79Pki9aoHxkPon76ktnYMeta } from "/app/apps/frontend/src/pages/account/upgrade-successful.vue?macro=true";
import { default as loginvWOTq9B41qLizNvXFXJM2IIpJKAEc_zBQ3omUtKRl0wMeta } from "/app/apps/frontend/src/pages/auth/login.vue?macro=true";
import { default as login_45from_45websiteHvEaHc1BotO4bbNyn9hHKd_8bg_yrYeoQlmg8tMrxcwMeta } from "/app/apps/frontend/src/pages/auth/login-from-website.vue?macro=true";
import { default as logoutjIAbrBLnTnf8AzMikE4EbSWAfkiTiS12KsGqgfi0gEYMeta } from "/app/apps/frontend/src/pages/auth/logout.vue?macro=true";
import { default as refreshElSml0bkatZmzRl_DUCfJ9TecAc7_njNNkZNTUs4IyoMeta } from "/app/apps/frontend/src/pages/auth/refresh.vue?macro=true";
import { default as indexxOeNv6nLivqFaDuaSEn0TeTMvMMrvY64AGBXp6NY440Meta } from "/app/apps/frontend/src/pages/auth/reset-password/index.vue?macro=true";
import { default as signup_45from_45websiteQ4XHIXIpvNHW_6eYy6nW2_IdWjFd_06PVGL_KR_r7_YMeta } from "/app/apps/frontend/src/pages/auth/signup-from-website.vue?macro=true";
import { default as signup_45teacherFgjXzfcno_g6827CYS1TruDkMYuvtwEOhV1SfcVV6WsMeta } from "/app/apps/frontend/src/pages/auth/signup-teacher.vue?macro=true";
import { default as signup_45verify_45emailcCUAJWK2dN43Pqasu1syX0NynIrty1usAuXFM9_6dkYMeta } from "/app/apps/frontend/src/pages/auth/signup-verify-email.vue?macro=true";
import { default as material_45editorxSZYj2B4e_ND6wUpmvHlJLkjmMWGY2bDGwW_qyA75NIMeta } from "/app/apps/frontend/src/pages/debug/material-editor.vue?macro=true";
import { default as aitest27m62u_QPH8WweIOXEBrFoEebNZgoKqIJQdnfd2nyOUMeta } from "/app/apps/frontend/src/pages/internal/aitest.vue?macro=true";
import { default as BoogieDropzonev1gmMkjVDv1aE6SZHUBjXVKHIiWGRSCwSK_JjIsxgTgMeta } from "/app/apps/frontend/src/pages/internal/BoogieDropzone.vue?macro=true";
import { default as canvastestETRPIh3LJQDs3U_IFWtsGbX5Wc_zdaiHTOFAGksJCAEMeta } from "/app/apps/frontend/src/pages/internal/canvastest.vue?macro=true";
import { default as dialogs8jsdeNuLX3PZsi68R7litZFhjyTc1BG7WDzBAJ2sAZYMeta } from "/app/apps/frontend/src/pages/internal/dialogs.vue?macro=true";
import { default as EmptyModalHRcSaJt3YmeEI4jHEQa6G3TFumFxAsGG2Evm3EOirhwMeta } from "/app/apps/frontend/src/pages/internal/EmptyModal.vue?macro=true";
import { default as icontestXh_xjbmHLKnEspT8ukxlZDbPRmBgXePiZemTvRY4w_cMeta } from "/app/apps/frontend/src/pages/internal/icontest.vue?macro=true";
import { default as styleguideAAz_m5npnze2CwnPkdV3JUy_s6rpKb_fEMQcJ_01wCYMeta } from "/app/apps/frontend/src/pages/internal/styleguide.vue?macro=true";
import { default as testkHO96JtIat_0mSLZhfgAxo_IWMtCtcMKYeI_MXaJeuoMeta } from "/app/apps/frontend/src/pages/internal/test.vue?macro=true";
import { default as timetabletestc2ohYg_TcDTdTXD9ebg1h1ZCcZvoG1eF_YSfieecR6cMeta } from "/app/apps/frontend/src/pages/internal/timetabletest.vue?macro=true";
import { default as imprintkfLoLXMc4lFfXoxjNTAOfnW11r_oL9IV_GbbPMorEdkMeta } from "/app/apps/frontend/src/pages/legal/imprint.vue?macro=true";
import { default as privacyx_DSx5_7Lxn7sk1wHLA53jmQp5Vw5EQKpbABvkHn2z4Meta } from "/app/apps/frontend/src/pages/legal/privacy.vue?macro=true";
import { default as termsggZLfVaK3I1eyunX67E0qj9ZC1Tr2qMAT2o8bZ90HagMeta } from "/app/apps/frontend/src/pages/legal/terms.vue?macro=true";
import { default as searchZMOH0a2pY0o_uzzuXsHhdSB9LEP1O5UF5eZ0usy4wbkMeta } from "/app/apps/frontend/src/pages/library/search.vue?macro=true";
import { default as create_45courseaypGhS_ZQG5TaPjjxATTYMqObOtLNiE3XPVCZVl3F2EMeta } from "/app/apps/frontend/src/pages/onboarding/create-course.vue?macro=true";
import { default as integrationY2lsxlmXZMjZipw88yckWAy_YuDdJfsXrWj_PJqUTdsMeta } from "/app/apps/frontend/src/pages/onboarding/integration.vue?macro=true";
import { default as ipi_45startrfkjUQ3F_UEs_1UUYmpgajB_Abn261pVtEy5FK_NVO8Meta } from "/app/apps/frontend/src/pages/onboarding/ipi-start.vue?macro=true";
import { default as evaluatemDVPLF4YFlu_Cvhf2oAjUx7Zfqm2ECqallGsQddimukMeta } from "/app/apps/frontend/src/pages/course/[courseid]/material/[materialid]/evaluate.vue?macro=true";
import { default as _91itemid_93EDv7Oq9hsdXjSAkY_aidq9jDf5UZLTkE6kNzvFTaN_sMeta } from "/app/apps/frontend/src/pages/c/[code]/item-detail/[id]/[itemid].vue?macro=true";
import { default as indexEc1VMtU3hVrPCbzFFhQ56kdU84A2OQzJcyb4X_VIUE0Meta } from "/app/apps/frontend/src/pages/c/[code]/item-detail/[id]/index.vue?macro=true";
import { default as _91topicid_93iHlPDkn5sFQ0cAcobW19XNHX_uJMM9UHAYTaCDEX_IYMeta } from "/app/apps/frontend/src/pages/course/[courseid]/topic/[topicid].vue?macro=true";
import { default as ai_45settingsLg4zK7uCoPxBxmTS77mIBmCxRf5QiIk9cxYCcJoBc74Meta } from "/app/apps/frontend/src/pages/course/[courseid]/ai-settings.vue?macro=true";
import { default as contentlv__4Y5ddCopmd3woYCXsw_8UZu4IH8ON_Bzb0byN78Meta } from "/app/apps/frontend/src/pages/course/[courseid]/content.vue?macro=true";
import { default as settingsLkKWiKLhNNCbBbHYCIjcxo6yPnZBO12LwZlDg5rSXf4Meta } from "/app/apps/frontend/src/pages/course/[courseid]/settings.vue?macro=true";
import { default as studentshul5lMCWTPDTZ4QCIAjRk6YeB7xXLY9iS1stXJNl_JYMeta } from "/app/apps/frontend/src/pages/course/[courseid]/students.vue?macro=true";
import { default as _91date_93Nr8KOEIoftNBxAjwSxcphFYPfIZ8psYNqFQUm2mVTQIMeta } from "/app/apps/frontend/src/pages/presentation/[courseId]/[date].vue?macro=true";
import { default as _91courseid_93dI6DVBqnWcwu3_OI2axjZlkkdaZs7Ys8o2a5W5cvn60Meta } from "/app/apps/frontend/src/pages/agenda/[filter]/course-detail/[courseid].vue?macro=true";
import { default as _91extensionId_93bHXMA6Te5bEgFxR_dkdcPH_9rSW7I4uygIVWbJEn_LMMeta } from "/app/apps/frontend/src/pages/agenda/[filter]/other/[extensionId].vue?macro=true";
import { default as _91filter_93b7pPOCCLRtEXd2cWTajl1_XPpoSM9gy2gMLCZIstHcsMeta } from "/app/apps/frontend/src/pages/agenda/[filter].vue?macro=true";
import { default as indexPKMMj0vSdKbOOPgigJ1DJM38T2pIC1jJDeh42RZ7ctUMeta } from "/app/apps/frontend/src/pages/c/[code]/index.vue?macro=true";
import { default as indexkSD3kPDuB_2cVxNk28X7IVKYZX8O8uTJkKlIX9tBctUMeta } from "/app/apps/frontend/src/pages/courses/[courseid]/index.vue?macro=true";
import { default as _91page_93FAc434J9EeK3gjg6S_UIv2zFgGe1Ab8fAzMM986j3nUMeta } from "/app/apps/frontend/src/pages/help/[page].vue?macro=true";
import { default as _91courseCodeRedirect_933aMTlSBzFjs681a7_aBmPGYFowHYV5VdF4GiktLCi_UMeta } from "/app/apps/frontend/src/pages/invite/[courseCodeRedirect].vue?macro=true";
import { default as indexzAdmSfS3wBN4wD7Vn1qflhZTlvapMhM082qd31BbdikMeta } from "/app/apps/frontend/src/pages/account/index.vue?macro=true";
import { default as indexVTWQdXIfDXPWq1yLx8HOIK1vgAS5_SEgIEu7d_yfLeYMeta } from "/app/apps/frontend/src/pages/agenda/index.vue?macro=true";
import { default as indexq2qrYnHOu4hGHZo_1uTBUfnFowFzBt8ooKB3ZHE3oxYMeta } from "/app/apps/frontend/src/pages/ai/index.vue?macro=true";
import { default as indexPgMVlzPiZmuBNnFGu8uuyRfrbc1CajFldxe7mY9lTb8Meta } from "/app/apps/frontend/src/pages/collaboration/index.vue?macro=true";
import { default as indexPKJ6yg5pAr5tszLGKNjOXplxiR2iiBtqYXrb5cgLTX4Meta } from "/app/apps/frontend/src/pages/course/index.vue?macro=true";
import { default as dashboardXWKo6D8_Oku0hmjsAh7d7bZJWSx9bU_T7CqFRDh4F4QMeta } from "/app/apps/frontend/src/pages/dashboard.vue?macro=true";
import { default as home_LXdZnc2d5SHP2aul9f_rFLIRxdabaMtRlXuq_yKPQcMeta } from "/app/apps/frontend/src/pages/home.vue?macro=true";
import { default as ipi_loadingWtZEFArtSU5Bj4cH8c6_c68ezqHagOqHSQxSXHZ8XrcMeta } from "/app/apps/frontend/src/pages/ipi/ipi_loading.vue?macro=true";
import { default as ipi76YEKmd8H4yKE4QElvP9vXYHBTJhp40LvjbKKezhB_kMeta } from "/app/apps/frontend/src/pages/ipi.vue?macro=true";
import { default as _91id_93cts6w0ov8QIjktv9U5sNzig2Nx42UXoJRmDRmQBjwdkMeta } from "/app/apps/frontend/src/pages/library/index/folder/[id].vue?macro=true";
import { default as unsortedEHajbAEnO8imGNtnm_rmCph3mgETV2sCuz2Xkor7JZUMeta } from "/app/apps/frontend/src/pages/library/index/unsorted.vue?macro=true";
import { default as indexl_QdEo9M_JuRe0RcoxyLV4wyzVc8jlef_luPTf8kCqQMeta } from "/app/apps/frontend/src/pages/library/index/index.vue?macro=true";
import { default as indexLIlwN8DMmXCCDbPZZxW_hPGgJh_83mkhLRZmj8F854AMeta } from "/app/apps/frontend/src/pages/library/index.vue?macro=true";
import { default as indexw27BFVMAA0ZO57Rgre1nbUJixxPyRCzsXBbBEx8tP3IMeta } from "/app/apps/frontend/src/pages/student-ai/index.vue?macro=true";
import { default as _91courseid_93fXxFBJiaDl_WXvZPGz1drDoo10WVb_RmrVd2TDinghUMeta } from "/app/apps/frontend/src/pages/timetable/course-detail/[courseid].vue?macro=true";
import { default as _91extensionId_9385sDx2f7fpgI93EJQNaWednTkRtqwHx0h1aHGH3uSVIMeta } from "/app/apps/frontend/src/pages/timetable/other/[extensionId].vue?macro=true";
import { default as editssGhtJD2IvA_3e4TWyoZEKgdmF9_WxkD1Kr9zY_kXfsMeta } from "/app/apps/frontend/src/pages/timetable/edit.vue?macro=true";
import { default as edit_45complexF37M26JPzb2RdjLXGLxlscA_hyEg1QjYcnzEz0QCbloMeta } from "/app/apps/frontend/src/pages/timetable/edit-complex.vue?macro=true";
import { default as vacationSIaZXlyZBhWLf5KM6RRuu11r6F0Q_LfpD03QvjuVjwsMeta } from "/app/apps/frontend/src/pages/timetable/vacation.vue?macro=true";
import { default as timetableW6e6OMLQk1ZEZ2FgXW2WQieUXOmO6Jhf04HtbiNQijcMeta } from "/app/apps/frontend/src/pages/timetable.vue?macro=true";
import { default as indexX5RGxEUWJpcWvV6_7QRlnhA20v28DfbgH8N7CcI7lL0Meta } from "/app/apps/frontend/src/pages/index.vue?macro=true";
export default [
  {
    name: "embed-teacher-ai-iframe_test",
    path: "/embed/teacher/ai/iframe_test",
    component: () => import("/app/apps/frontend/src/pages/embed/teacher/ai/iframe_test.vue")
  },
  {
    name: "embed-student-course-code",
    path: "/embed/student/course/:code()",
    meta: _91code_93mZ0FfbUA8t1sgey73R4COXrLaNwUCxgsNKtLKPkkVPoMeta || {},
    component: () => import("/app/apps/frontend/src/pages/embed/student/course/[code].vue"),
    children: [
  {
    name: "embed-student-course-code-item-detail-id",
    path: "item-detail/:id()",
    component: () => import("/app/apps/frontend/src/pages/embed/student/course/[code]/item-detail/[id]/index.vue")
  }
]
  },
  {
    name: "embed-teacher-course-code",
    path: "/embed/teacher/course/:code()",
    meta: _91code_93HTMA7d8XHlKRh6aL33Cu5zPnJTQjFj0JTjxCz_kIJAgMeta || {},
    component: () => import("/app/apps/frontend/src/pages/embed/teacher/course/[code].vue")
  },
  {
    name: "embed-teacher-period-courseId",
    path: "/embed/teacher/period/:courseId()",
    component: () => import("/app/apps/frontend/src/pages/embed/teacher/period/[courseId].vue")
  },
  {
    name: "student-ai-assignments-preview-id",
    path: "/student-ai/assignments/preview/:id()",
    meta: { ...(_91id_93xkR_H_OJATUIWvU6Ltj14Wzs8kUBtpXJn5Vjb6PU0mIMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/student-ai/assignments/preview/[id].vue")
  },
  {
    name: "student-ai-templates-preview-id",
    path: "/student-ai/templates/preview/:id()",
    meta: { ...(_91id_93rqmjAq0xHuRYcow9TlUPNpDuNvF9TT4xZxScBwhBRAQMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/student-ai/templates/preview/[id].vue")
  },
  {
    name: "student-ai-templates-public-preview-id",
    path: "/student-ai/templates/public-preview/:id()",
    meta: { ...(_91id_93LXahq8ZvnNIN40i6LEBDF3FlxxxxYdA9GcWkVBjgSxEMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/student-ai/templates/public-preview/[id].vue")
  },
  {
    name: "auth-integration-admininfo",
    path: "/auth/integration/admininfo",
    meta: admininfosUwQxeSgNauT769PNEKvV2kjq6yjRZdDm3KhX_Z7HlEMeta || {},
    component: () => import("/app/apps/frontend/src/pages/auth/integration/admininfo.vue")
  },
  {
    name: "auth-integration-authenticate",
    path: "/auth/integration/authenticate",
    meta: authenticateOGw6Vt_FfXHFyVGUJISZAhnazH_tI7k_8_qupc_hFqsMeta || {},
    component: () => import("/app/apps/frontend/src/pages/auth/integration/authenticate.vue")
  },
  {
    name: "auth-integration-not_ready",
    path: "/auth/integration/not_ready",
    meta: not_ready_7XICRBXlcjdszwSVo_tLlgpjzCaYe0kD6WJvUMraqcMeta || {},
    component: () => import("/app/apps/frontend/src/pages/auth/integration/not_ready.vue")
  },
  {
    name: "auth-integration-not_ready_student",
    path: "/auth/integration/not_ready_student",
    meta: not_ready_studentukdnyHVi_ZYZ7bnhrWGEilS7biGcLceCCaxang4sdWYMeta || {},
    component: () => import("/app/apps/frontend/src/pages/auth/integration/not_ready_student.vue")
  },
  {
    name: "embed-error-no-auth",
    path: "/embed/error/no-auth",
    meta: no_45authyw_IDyAX3GLe6d1m1mSGf0a2QyH5Xki1ejAPLj1gX5AMeta || {},
    component: () => import("/app/apps/frontend/src/pages/embed/error/no-auth.vue")
  },
  {
    name: "embed-student-no-course",
    path: "/embed/student/no-course",
    meta: no_45courseYC4rPQhoJZYIhdOvIG4h1HomZZPO_rnQ4d_8sZF4F3MMeta || {},
    component: () => import("/app/apps/frontend/src/pages/embed/student/no-course.vue")
  },
  {
    name: "embed-teacher-ai",
    path: "/embed/teacher/ai",
    meta: { ...(indexnjPM4XY7Hh6QYM3ocWBFtvTmPuX1ZjrCxDxV0NSlG0oMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/embed/teacher/ai/index.vue")
  },
  {
    name: "embed-teacher-error",
    path: "/embed/teacher/error",
    component: () => import("/app/apps/frontend/src/pages/embed/teacher/error.vue")
  },
  {
    name: "embed-teacher-no-account",
    path: "/embed/teacher/no-account",
    meta: no_45accountTYZvuDk2_OOoYF4oUYpeZMmXygH9fJMrTEzYAvoxwJYMeta || {},
    component: () => import("/app/apps/frontend/src/pages/embed/teacher/no-account.vue")
  },
  {
    name: "embed-teacher-no-course-mapping",
    path: "/embed/teacher/no-course-mapping",
    meta: no_45course_45mappingpzg50rrvYPWtONuIzp4_FGSfnxy4KHZot0_SqDQ6oAUMeta || {},
    component: () => import("/app/apps/frontend/src/pages/embed/teacher/no-course-mapping.vue")
  },
  {
    name: "collaboration-template-templateid-ai-settings",
    path: "/collaboration/template/:templateid()/ai-settings",
    meta: { ...(ai_45settingsRKFUK1WOpSssO_xMy8UjzxPTQ_7nnIDJt6Egttn6tS8Meta || {}), ...{"middleware":["is-teacher"]} },
    component: () => import("/app/apps/frontend/src/pages/collaboration/template/[templateid]/ai-settings.vue")
  },
  {
    name: "collaboration-template-templateid-collaboration",
    path: "/collaboration/template/:templateid()/collaboration",
    meta: { ...(collaborationW66LmG3h_Nl_r6g68mwjgMGIpQaaZlepAMqm0HhmcMwMeta || {}), ...{"middleware":["is-teacher"]} },
    component: () => import("/app/apps/frontend/src/pages/collaboration/template/[templateid]/collaboration.vue")
  },
  {
    name: "collaboration-template-templateid-settings",
    path: "/collaboration/template/:templateid()/settings",
    meta: { ...(settings9xLitFfz0eslAFHbMGAi6YkZ6j_FEujp8xJbjg9Dt60Meta || {}), ...{"middleware":["is-teacher"]} },
    component: () => import("/app/apps/frontend/src/pages/collaboration/template/[templateid]/settings.vue")
  },
  {
    name: "auth-reset-password-email-code",
    path: "/auth/reset-password/:email()/:code()",
    component: () => import("/app/apps/frontend/src/pages/auth/reset-password/[email]/[code].vue")
  },
  {
    name: "ai-chat-id",
    path: "/ai/chat/:id()",
    meta: { ...(_91id_9328a0MFrU_CI4X_4oK6wqAcr2K6f97D2vUt5egAAUq3wMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/ai/chat/[id].vue")
  },
  {
    name: "collaboration-template-templateid",
    path: "/collaboration/template/:templateid()",
    meta: { ...(index9eF__7BaBacCkwqCQpBIY6vZEeJn2LtIeZku8DhbbTUMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/collaboration/template/[templateid]/index.vue")
  },
  {
    name: "invite-course-courseCode",
    path: "/invite/course/:courseCode()",
    meta: _91courseCode_93zJSfJ1_CGVq6iVcmy23eIygogokABF_H7uLhf90RDa0Meta || {},
    component: () => import("/app/apps/frontend/src/pages/invite/course/[courseCode].vue")
  },
  {
    name: "invite-tenant-tenantCode",
    path: "/invite/tenant/:tenantCode()",
    meta: _91tenantCode_93Fs0dRb1ImnHzEAhfSIYCz_HxZTWnXE7kFmxngYOIfM8Meta || {},
    component: () => import("/app/apps/frontend/src/pages/invite/tenant/[tenantCode].vue")
  },
  {
    name: "library-material-id",
    path: "/library/material/:id()",
    meta: { ...(_91id_93ISS5HtTnVBM5X9W947BX8ZT1KS6yTNrAV1KZMPUBIzoMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/library/material/[id].vue")
  },
  {
    name: "library-topic-id",
    path: "/library/topic/:id()",
    meta: { ...(_91id_93Awpi_IefJ62wYW5G8SRS1pcMvN3mqGIcow5jco3XuQgMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/library/topic/[id].vue")
  },
  {
    name: "presentation-material-id",
    path: "/presentation/material/:id()",
    component: () => import("/app/apps/frontend/src/pages/presentation/material/[id].vue")
  },
  {
    name: "account-discoverpro",
    path: "/account/discoverpro",
    meta: discoverproNyMWlV8yQp4xVshCgRy1ckZgou78Vi37KUwlCO8AnrUMeta || {},
    component: () => import("/app/apps/frontend/src/pages/account/discoverpro.vue")
  },
  {
    name: "account-integrations",
    path: "/account/integrations",
    meta: integrationsC1r5O4D0a4OA79rpZJmbAWxZMIw_Ch6h7ha0v_m9IQUMeta || {},
    component: () => import("/app/apps/frontend/src/pages/account/integrations.vue")
  },
  {
    name: "account-profile",
    path: "/account/profile",
    meta: profileUnF62GpJiyfeo2VTAnNkJcNiENjOiQESe4lR3Ki7DzQMeta || {},
    component: () => import("/app/apps/frontend/src/pages/account/profile.vue")
  },
  {
    name: "account-upgrade",
    path: "/account/upgrade",
    meta: { ...(upgradeukcMHmOU6jmEjVJ_c2ZQ4FG53eh3u0_a47jOo33fn08Meta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/account/upgrade.vue")
  },
  {
    name: "account-upgrade-successful",
    path: "/account/upgrade-successful",
    meta: upgrade_45successfulzMZYY98uz65fVM9MP2u6DSD79Pki9aoHxkPon76ktnYMeta || {},
    component: () => import("/app/apps/frontend/src/pages/account/upgrade-successful.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/app/apps/frontend/src/pages/auth/login.vue")
  },
  {
    name: "auth-login-from-website",
    path: "/auth/login-from-website",
    component: () => import("/app/apps/frontend/src/pages/auth/login-from-website.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    component: () => import("/app/apps/frontend/src/pages/auth/logout.vue")
  },
  {
    name: "auth-refresh",
    path: "/auth/refresh",
    component: () => import("/app/apps/frontend/src/pages/auth/refresh.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    component: () => import("/app/apps/frontend/src/pages/auth/reset-password/index.vue")
  },
  {
    name: "auth-signup-from-website",
    path: "/auth/signup-from-website",
    component: () => import("/app/apps/frontend/src/pages/auth/signup-from-website.vue")
  },
  {
    name: "auth-signup-teacher",
    path: "/auth/signup-teacher",
    component: () => import("/app/apps/frontend/src/pages/auth/signup-teacher.vue")
  },
  {
    name: "auth-signup-verify-email",
    path: "/auth/signup-verify-email",
    component: () => import("/app/apps/frontend/src/pages/auth/signup-verify-email.vue")
  },
  {
    name: "debug-material-editor",
    path: "/debug/material-editor",
    component: () => import("/app/apps/frontend/src/pages/debug/material-editor.vue")
  },
  {
    name: "internal-aitest",
    path: "/internal/aitest",
    component: () => import("/app/apps/frontend/src/pages/internal/aitest.vue")
  },
  {
    name: "internal-BoogieDropzone",
    path: "/internal/BoogieDropzone",
    component: () => import("/app/apps/frontend/src/pages/internal/BoogieDropzone.vue")
  },
  {
    name: "internal-canvastest",
    path: "/internal/canvastest",
    component: () => import("/app/apps/frontend/src/pages/internal/canvastest.vue")
  },
  {
    name: "internal-dialogs",
    path: "/internal/dialogs",
    component: () => import("/app/apps/frontend/src/pages/internal/dialogs.vue")
  },
  {
    name: "internal-EmptyModal",
    path: "/internal/EmptyModal",
    component: () => import("/app/apps/frontend/src/pages/internal/EmptyModal.vue")
  },
  {
    name: "internal-icontest",
    path: "/internal/icontest",
    component: () => import("/app/apps/frontend/src/pages/internal/icontest.vue")
  },
  {
    name: "internal-styleguide",
    path: "/internal/styleguide",
    component: () => import("/app/apps/frontend/src/pages/internal/styleguide.vue")
  },
  {
    name: "internal-test",
    path: "/internal/test",
    component: () => import("/app/apps/frontend/src/pages/internal/test.vue")
  },
  {
    name: "internal-timetabletest",
    path: "/internal/timetabletest",
    meta: timetabletestc2ohYg_TcDTdTXD9ebg1h1ZCcZvoG1eF_YSfieecR6cMeta || {},
    component: () => import("/app/apps/frontend/src/pages/internal/timetabletest.vue")
  },
  {
    name: "legal-imprint",
    path: "/legal/imprint",
    meta: imprintkfLoLXMc4lFfXoxjNTAOfnW11r_oL9IV_GbbPMorEdkMeta || {},
    component: () => import("/app/apps/frontend/src/pages/legal/imprint.vue")
  },
  {
    name: "legal-privacy",
    path: "/legal/privacy",
    meta: privacyx_DSx5_7Lxn7sk1wHLA53jmQp5Vw5EQKpbABvkHn2z4Meta || {},
    component: () => import("/app/apps/frontend/src/pages/legal/privacy.vue")
  },
  {
    name: "legal-terms",
    path: "/legal/terms",
    meta: termsggZLfVaK3I1eyunX67E0qj9ZC1Tr2qMAT2o8bZ90HagMeta || {},
    component: () => import("/app/apps/frontend/src/pages/legal/terms.vue")
  },
  {
    name: "library-search",
    path: "/library/search",
    meta: { ...(searchZMOH0a2pY0o_uzzuXsHhdSB9LEP1O5UF5eZ0usy4wbkMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/library/search.vue")
  },
  {
    name: "onboarding-create-course",
    path: "/onboarding/create-course",
    component: () => import("/app/apps/frontend/src/pages/onboarding/create-course.vue")
  },
  {
    name: "onboarding-integration",
    path: "/onboarding/integration",
    meta: { ...(integrationY2lsxlmXZMjZipw88yckWAy_YuDdJfsXrWj_PJqUTdsMeta || {}), ...{"middleware":["is-teacher","can-create-course"]} },
    component: () => import("/app/apps/frontend/src/pages/onboarding/integration.vue")
  },
  {
    name: "onboarding-ipi-start",
    path: "/onboarding/ipi-start",
    meta: { ...(ipi_45startrfkjUQ3F_UEs_1UUYmpgajB_Abn261pVtEy5FK_NVO8Meta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/onboarding/ipi-start.vue")
  },
  {
    name: "course-courseid-material-materialid-evaluate",
    path: "/course/:courseid()/material/:materialid()/evaluate",
    meta: { ...(evaluatemDVPLF4YFlu_Cvhf2oAjUx7Zfqm2ECqallGsQddimukMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/course/[courseid]/material/[materialid]/evaluate.vue")
  },
  {
    name: "c-code-item-detail-id-itemid",
    path: "/c/:code()/item-detail/:id()/:itemid()",
    component: () => import("/app/apps/frontend/src/pages/c/[code]/item-detail/[id]/[itemid].vue")
  },
  {
    name: "c-code-item-detail-id",
    path: "/c/:code()/item-detail/:id()",
    component: () => import("/app/apps/frontend/src/pages/c/[code]/item-detail/[id]/index.vue")
  },
  {
    name: "course-courseid-topic-topicid",
    path: "/course/:courseid()/topic/:topicid()",
    meta: { ...(_91topicid_93iHlPDkn5sFQ0cAcobW19XNHX_uJMM9UHAYTaCDEX_IYMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/course/[courseid]/topic/[topicid].vue")
  },
  {
    name: "course-courseid-ai-settings",
    path: "/course/:courseid()/ai-settings",
    meta: { ...(ai_45settingsLg4zK7uCoPxBxmTS77mIBmCxRf5QiIk9cxYCcJoBc74Meta || {}), ...{"middleware":["is-teacher"]} },
    component: () => import("/app/apps/frontend/src/pages/course/[courseid]/ai-settings.vue")
  },
  {
    name: "course-courseid-content",
    path: "/course/:courseid()/content",
    meta: { ...(contentlv__4Y5ddCopmd3woYCXsw_8UZu4IH8ON_Bzb0byN78Meta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/course/[courseid]/content.vue")
  },
  {
    name: "course-courseid-settings",
    path: "/course/:courseid()/settings",
    meta: { ...(settingsLkKWiKLhNNCbBbHYCIjcxo6yPnZBO12LwZlDg5rSXf4Meta || {}), ...{"middleware":["is-teacher"]} },
    component: () => import("/app/apps/frontend/src/pages/course/[courseid]/settings.vue")
  },
  {
    name: "course-courseid-students",
    path: "/course/:courseid()/students",
    meta: { ...(studentshul5lMCWTPDTZ4QCIAjRk6YeB7xXLY9iS1stXJNl_JYMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/course/[courseid]/students.vue")
  },
  {
    name: "presentation-courseId-date",
    path: "/presentation/:courseId()/:date()",
    component: () => import("/app/apps/frontend/src/pages/presentation/[courseId]/[date].vue")
  },
  {
    name: "agenda-filter",
    path: "/agenda/:filter()",
    meta: _91filter_93b7pPOCCLRtEXd2cWTajl1_XPpoSM9gy2gMLCZIstHcsMeta || {},
    component: () => import("/app/apps/frontend/src/pages/agenda/[filter].vue"),
    children: [
  {
    name: "agenda-filter-course-detail-courseid",
    path: "course-detail/:courseid()",
    meta: _91courseid_93dI6DVBqnWcwu3_OI2axjZlkkdaZs7Ys8o2a5W5cvn60Meta || {},
    component: () => import("/app/apps/frontend/src/pages/agenda/[filter]/course-detail/[courseid].vue")
  },
  {
    name: "agenda-filter-other-extensionId",
    path: "other/:extensionId()",
    meta: _91extensionId_93bHXMA6Te5bEgFxR_dkdcPH_9rSW7I4uygIVWbJEn_LMMeta || {},
    component: () => import("/app/apps/frontend/src/pages/agenda/[filter]/other/[extensionId].vue")
  }
]
  },
  {
    name: "c-code",
    path: "/c/:code()",
    meta: indexPKMMj0vSdKbOOPgigJ1DJM38T2pIC1jJDeh42RZ7ctUMeta || {},
    component: () => import("/app/apps/frontend/src/pages/c/[code]/index.vue")
  },
  {
    name: "courses-courseid",
    path: "/courses/:courseid()",
    meta: { ...(indexkSD3kPDuB_2cVxNk28X7IVKYZX8O8uTJkKlIX9tBctUMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/courses/[courseid]/index.vue")
  },
  {
    name: "help-page",
    path: "/help/:page()",
    component: () => import("/app/apps/frontend/src/pages/help/[page].vue")
  },
  {
    name: "invite-courseCodeRedirect",
    path: "/invite/:courseCodeRedirect()",
    component: () => import("/app/apps/frontend/src/pages/invite/[courseCodeRedirect].vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexzAdmSfS3wBN4wD7Vn1qflhZTlvapMhM082qd31BbdikMeta || {},
    component: () => import("/app/apps/frontend/src/pages/account/index.vue")
  },
  {
    name: "agenda",
    path: "/agenda",
    component: () => import("/app/apps/frontend/src/pages/agenda/index.vue")
  },
  {
    name: "ai",
    path: "/ai",
    meta: { ...(indexq2qrYnHOu4hGHZo_1uTBUfnFowFzBt8ooKB3ZHE3oxYMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/ai/index.vue")
  },
  {
    name: "collaboration",
    path: "/collaboration",
    meta: { ...(indexPgMVlzPiZmuBNnFGu8uuyRfrbc1CajFldxe7mY9lTb8Meta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/collaboration/index.vue")
  },
  {
    name: "course",
    path: "/course",
    meta: { ...(indexPKJ6yg5pAr5tszLGKNjOXplxiR2iiBtqYXrb5cgLTX4Meta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/course/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/app/apps/frontend/src/pages/dashboard.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/app/apps/frontend/src/pages/home.vue")
  },
  {
    name: "ipi",
    path: "/ipi",
    meta: { ...(ipi76YEKmd8H4yKE4QElvP9vXYHBTJhp40LvjbKKezhB_kMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/ipi.vue"),
    children: [
  {
    name: "ipi-ipi_loading",
    path: "ipi_loading",
    meta: { ...(ipi_loadingWtZEFArtSU5Bj4cH8c6_c68ezqHagOqHSQxSXHZ8XrcMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/ipi/ipi_loading.vue")
  }
]
  },
  {
    name: indexLIlwN8DMmXCCDbPZZxW_hPGgJh_83mkhLRZmj8F854AMeta?.name,
    path: "/library",
    meta: { ...(indexLIlwN8DMmXCCDbPZZxW_hPGgJh_83mkhLRZmj8F854AMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/library/index.vue"),
    children: [
  {
    name: "library-index-folder-id",
    path: "folder/:id()",
    meta: { ...(_91id_93cts6w0ov8QIjktv9U5sNzig2Nx42UXoJRmDRmQBjwdkMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/library/index/folder/[id].vue")
  },
  {
    name: "library-index-unsorted",
    path: "unsorted",
    meta: { ...(unsortedEHajbAEnO8imGNtnm_rmCph3mgETV2sCuz2Xkor7JZUMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/library/index/unsorted.vue")
  },
  {
    name: "library-index",
    path: "",
    meta: { ...(indexl_QdEo9M_JuRe0RcoxyLV4wyzVc8jlef_luPTf8kCqQMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/library/index/index.vue")
  }
]
  },
  {
    name: "student-ai",
    path: "/student-ai",
    meta: { ...(indexw27BFVMAA0ZO57Rgre1nbUJixxPyRCzsXBbBEx8tP3IMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/student-ai/index.vue")
  },
  {
    name: "timetable",
    path: "/timetable",
    meta: { ...(timetableW6e6OMLQk1ZEZ2FgXW2WQieUXOmO6Jhf04HtbiNQijcMeta || {}), ...{"middleware":["scroll-top"]} },
    component: () => import("/app/apps/frontend/src/pages/timetable.vue"),
    children: [
  {
    name: "timetable-course-detail-courseid",
    path: "course-detail/:courseid()",
    meta: _91courseid_93fXxFBJiaDl_WXvZPGz1drDoo10WVb_RmrVd2TDinghUMeta || {},
    component: () => import("/app/apps/frontend/src/pages/timetable/course-detail/[courseid].vue")
  },
  {
    name: "timetable-other-extensionId",
    path: "other/:extensionId()",
    meta: _91extensionId_9385sDx2f7fpgI93EJQNaWednTkRtqwHx0h1aHGH3uSVIMeta || {},
    component: () => import("/app/apps/frontend/src/pages/timetable/other/[extensionId].vue")
  },
  {
    name: "timetable-edit",
    path: "edit",
    meta: editssGhtJD2IvA_3e4TWyoZEKgdmF9_WxkD1Kr9zY_kXfsMeta || {},
    component: () => import("/app/apps/frontend/src/pages/timetable/edit.vue")
  },
  {
    name: "timetable-edit-complex",
    path: "edit-complex",
    meta: edit_45complexF37M26JPzb2RdjLXGLxlscA_hyEg1QjYcnzEz0QCbloMeta || {},
    component: () => import("/app/apps/frontend/src/pages/timetable/edit-complex.vue")
  },
  {
    name: "timetable-vacation",
    path: "vacation",
    meta: vacationSIaZXlyZBhWLf5KM6RRuu11r6F0Q_LfpD03QvjuVjwsMeta || {},
    component: () => import("/app/apps/frontend/src/pages/timetable/vacation.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/frontend/src/pages/index.vue")
  }
]